/* Dentelle Riyadh - replace currency text Shopify renders inside price elements
   with the brand's PNG Saudi Riyal symbol. */
(function () {
  const SYMBOL_URL = window.DENTELLE_SAR_URL;
  if (!SYMBOL_URL) return;

  const CURRENCY_RE = /\s*(SAR|SR|ر\.?\s*س)\b/i;
  const PRICE_SELECTOR = [
    '.price',
    '.price__regular',
    '.price-item',
    '.price__amount',
    '.product__price',
    '.cart__price',
    '.cart-items__price',
    '.cart-page__item-price',
    '.cart-page__summary-line',
    '.cart-page__summary-total',
    '.collections-card__meta',
    '[data-price]',
    '.money'
  ].join(',');

  function buildSymbol() {
    const img = document.createElement('img');
    img.src = SYMBOL_URL;
    img.alt = 'Saudi Riyal';
    img.className = 'dentelle-sar-symbol';
    img.setAttribute('aria-label', 'Saudi Riyal');
    return img;
  }

  function swap(node) {
    if (!node) return;

    const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null);
    const targets = [];
    while (walker.nextNode()) {
      const textNode = walker.currentNode;
      if (CURRENCY_RE.test(textNode.nodeValue)) targets.push(textNode);
    }

    targets.forEach((textNode) => {
      const value = textNode.nodeValue;
      const match = value.match(CURRENCY_RE);
      if (!match) return;

      const before = value.slice(0, match.index);
      const after = value.slice(match.index + match[0].length);
      const frag = document.createDocumentFragment();
      if (before) frag.appendChild(document.createTextNode(before));
      frag.appendChild(buildSymbol());
      if (after) frag.appendChild(document.createTextNode(after));
      textNode.parentNode.replaceChild(frag, textNode);
    });
  }

  function scan(root) {
    const scope = root || document;
    if (scope.matches && scope.matches(PRICE_SELECTOR)) swap(scope);
    scope.querySelectorAll?.(PRICE_SELECTOR).forEach(swap);
  }

  document.addEventListener('DOMContentLoaded', function () { scan(); });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'characterData') {
        const priceNode = mutation.target.parentElement?.closest?.(PRICE_SELECTOR);
        if (priceNode) swap(priceNode);
        return;
      }

      const priceNode = mutation.target?.closest?.(PRICE_SELECTOR);
      if (priceNode) swap(priceNode);

      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) scan(node);
      });
    });
  });

  observer.observe(document.body, { childList: true, characterData: true, subtree: true });
})();
